import React, { FunctionComponent } from "react"
import Upload from "../../../components/Upload/Upload"
import { iNews } from "../../../definitions/News"

interface iProps {
  item?: iNews
}

const NewsUploads: FunctionComponent<iProps> = ({ item }) => {
  return (
    <>
      <Upload
        name="poster"
        label="Upload poster"
        initialFiles={[item?.poster || ""]}
        maxFiles={1}
        fileCollection="Files_NewsPosters"
        fileType={["image/png", "image/jpeg"]}
      />
    </>
  )
}

export default NewsUploads
